module.exports = __webpack_public_path__ + "img/1519816168.432aae22.jpg";